import React, { useContext, useEffect, useState } from "react";
import EditProfile from "./EditAndViewProfile/EditProfile";
import ViewProfile from "./EditAndViewProfile/ViewProfile";
import Modal from "./tutorModal";
import { AuthContextTwo } from "../../../contexts/AuthProviderTwo";
import TutorModal from "./tutorModal";
import JobBoardLoader from "../../Shared/pageLoaderGreen/JobBoardLoader";
import LoaderTutorProfileGreen from "../../Shared/pageLoaderGreen/LoaderTutorProfileGreen";

const TutorProfileGreen = () => {
  const [active, setActive] = useState("viewProfile");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleProfileView = () => {
    setActive((prevActive) =>
      prevActive === "viewProfile" ? "editProfile" : "viewProfile"
    );
  };

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const { userTwo, logOutTwo } = useContext(AuthContextTwo);

  const [imageUrl, setImageUrl] = useState(
    "https://img.freepik.com/free-photo/portrait-expressive-young-man-wearing-formal-suit_273609-6943.jpg"
  );
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false); // Add loading state
  const [Mainloading, setMainLoading] = useState(true);
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setImageFile(file);
  };

  const updateImage = async () => {
    if (!imageFile) {
      console.error("Please select an image.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("image", imageFile);

    const imgbbApiKey = "4caaf6556f5639c7ac2506637cfd88d2";
    const imgbbUploadUrl = `https://api.imgbb.com/1/upload?key=${imgbbApiKey}`;

    try {
      const response = await fetch(imgbbUploadUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.data && data.data.url) {
        setImageUrl(data.data.url);

        // Update the image URL in the DOM
        const imageElement = document.getElementById("profileImage");
        if (imageElement) {
          imageElement.src = data.data.url;
        }

        // Update the image URL on the server
        const updateUrl = "https://tutor-tree-server-1.vercel.app/user/img";
        const updateResponse = await fetch(updateUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: userTwo.email,
            img: data.data.url,
          }),
        });

        const updateData = await updateResponse.json();
        console.log("Image URL updated on the server:", updateData);
      } else {
        console.error("Failed to upload image to imgBB.");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setLoading(false); // Set loading to false after upload
      // Close the modal after upload
      handleButtonClick();
    }
  };
  const [profileData, setProfileData] = useState([]);
  const [validPercentage, setValidPercentage] = useState(0);

  const fetchData = async () => {
    const UserEmail = userTwo?.email; // Ensure this variable has the correct email value.
    const url = `https://tutor-tree-server-1.vercel.app/user/${UserEmail}`;
    console.log("url", url);
    const res = await fetch(url);
    const data = await res.json();
    setProfileData(data);
    setMainLoading(false);
    calculateValidPercentage(data);
  };

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(() => {
      fetchData();
    }, 1000); 

    return () => clearInterval(intervalId); 
  }, []);


  const calculateValidPercentage = (data) => {
    // Assuming data is an array of profile objects
    if (!Array.isArray(data) || data.length === 0) {
      setValidPercentage(0);
      return;
    }

    // Fields to consider for percentage calculation
    const fields = [
      'name',
      'email',
      'phone',
      'area',
      'city',
      'emergencyNmbr',
      'gender',
      'religion',
      'HSCgroup',
      'HSCinstitute',
      'HSCresult',
      'HonsInstitute',
      'HonsMajor',
      'HonsSemester',
      'MastersInstitute',
      'MastersMejor',
      'MastersSemester',
      'SSCgroup',
      'SSCinstitute',
      'experience',
      'preArea1',
      'preArea2',
      'preCategories1',
      'preCategories2',
      'preCategories3',
      'preCategories4',
      'preClasses1',
      'preClasses2',
      'preClasses3',
      'preLocation1',
      'preSubject1',
      'preSubject2',
    ];

    let totalValidFields = 0;
    let totalFields = fields.length * data.length;

    data.forEach(profile => {
      totalValidFields += fields.filter(field => profile[field] && profile[field].toString().trim() !== '').length;
    });

    // Calculate the overall percentage of valid fields across all profiles
    const percentage = (totalValidFields / totalFields) * 100;
    setValidPercentage(percentage);
  };

  useEffect(() => {
    fetchData();
  }, []);



  const [isOpen, setIsOpen] = useState(false);

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  ///////////////////////select data ////////////////////////////

  if (Mainloading) return <div className=""><LoaderTutorProfileGreen></LoaderTutorProfileGreen></div>;

  return (
    <div className="bg-green-100 h-screen px-5 pt-5 z-40 zMain">
      <div className="flex flex-row gap-5">
        <div className="bg-white rounded-lg h-[640px] w-[25%] flex flex-col gap-5 px-5">
          <div className="w-full h-64   flex items-center justify-center">
            {active === "viewProfile" ? (
              <div className="flex justify-center  items-center">
                {profileData.map((data) => (
                  <div
                    className="w-full flex-col h-48 mt-5 rounded-t-lg relative flex justify-center items-center"
                    key={data.img}
                  >
                    {data.img ? (
                      <img
                        class="rounded w-36 h-36"
                        src={data.img}
                        alt="Extra large avatar"
                      />
                    ) : (
                      <div className="flex items-center justify-center">
                        <img
                          id="profileImage"
                          className="w-36 h-36 rounded-t-lg"
                          src="https://i.ibb.co/BsSBQBp/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-vector.png"
                          alt=""
                        />
                      </div>
                    )}
                    <h1 className="text-md mt-5 modalTitle font-montserrat text-green-900">
                      Tutor Id: {data._id.slice(-6)}
                    </h1>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <div>
                  <button onClick={openModal}>
                    <div>
                      {profileData.map((data) => (
                        <div
                          className="w-full flex-col h-48 mt-5 rounded-t-lg relative flex justify-center items-center"
                          key={data.img}
                        >
                          {data.img ? (
                            <img
                              class="rounded w-36 h-36"
                              src={data.img}
                              alt="Extra large avatar"
                            />
                          ) : (
                            <div className="flex items-center justify-center">
                              <img
                                id="profileImage"
                                className="w-36 h-36 rounded-t-lg"
                                src="https://i.ibb.co/BsSBQBp/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-vector.png"
                                alt=""
                              />
                            </div>
                          )}
                          <img
                            className="absolute bottom-12 right-3 h-8 w-8 rounded"
                            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PGNpcmNsZSBjeD0iMjU2IiBjeT0iMjU2IiByPSIyNTYiIGZpbGw9IiMwMDgwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMyMTk2ZjMiIGNsYXNzPSIiPjwvY2lyY2xlPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTI1NiAzMjQuODE3YTY2LjEyIDY2LjEyIDAgMSAwLTY2LjEyMS02Ni4xMTdBNjYuMTk1IDY2LjE5NSAwIDAgMCAyNTYgMzI0LjgxN3ptMC0xNTQuNjU0YTg4LjUzNCA4OC41MzQgMCAxIDEtODguNTMxIDg4LjUzN0E4OC42MzYgODguNjM2IDAgMCAxIDI1NiAxNzAuMTYzem0xNjIuNSAxOTYuMzA4YTE1LjQyMSAxNS40MjEgMCAwIDEtMTUuNDEgMTUuNDExSDEwOC45MTFBMTUuNDI0IDE1LjQyNCAwIDAgMSA5My41IDM2Ni40NzFWMTcxLjI4NmExNS40MjQgMTUuNDI0IDAgMCAxIDE1LjQxLTE1LjQxMmg3NC43YTUuNiA1LjYgMCAwIDAgNS4yMzItMy42bDE2LjA0NS00MS45MmgxMDIuMjI1bDE2LjA0OCA0MS45MmE1LjU4NSA1LjU4NSAwIDAgMCA1LjIyOSAzLjZoNzQuN2ExNS40MjYgMTUuNDI2IDAgMCAxIDE1LjQxIDE1LjQxMnoiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiNmZmZmZmYiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9zdmc+"
                          />
                          <h1 className="text-md mt-5 modalTitle font-montserrat text-green-900">
                            Tutor Id: {data._id.slice(-6)}
                          </h1>
                        </div>
                      ))}
                    </div>
                  </button>
                </div>
              </div>
            )}
          </div>
       
         <div>
         <div className="flex justify-center items-center py-2 bg-green-400">
            <h1 className="text-sm font-montserrat rounded text-white modalTitle">Profile Completed: {validPercentage.toFixed(2)}%</h1>

            </div>
         
          <button
            className="w-full py-2 bg-green-700 mt-2 text-md rounded font-montserrat modalTitle text-white"
            onClick={toggleProfileView}
          >
            {active === "viewProfile" ? "Edit Profile" : "View Profile"}
          </button>
         </div>

          <div className="">
            {profileData.map((info) => (
              <div className="flex flex-col gap-5">
                <div className="flex flex-row gap-2">
                  <div>
                     <img className="w-6" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ1Ljc5NSA1Ny41NTcgMi42MzggMjYuMTY3bC0uMTM4LjA3djQ3LjVhOS41IDkuNSAwIDAgMCA5LjUgOS41aDc2YTkuNSA5LjUgMCAwIDAgOS41LTkuNVYyNi4xMjRsLS4wMjUtLjAxMy00My4yNyAzMS40NDdhNy4xNSA3LjE1IDAgMCAxLTguNDEtLjAwMXoiIGZpbGw9IiM4MDgwODAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSIiPjwvcGF0aD48cGF0aCBkPSJtNTQuMjA2IDQ1LjgyNyAzOC4zMjktMjcuODc0Yy0xLjM0My0uNzM0LTIuODg4LTEuMTktNC41MzUtMS4xOUgxMmMtMS42NDcgMC0zLjE2Ny40NTYtNC41MzUgMS4xOWwzOC4zMyAyNy44NzRhNy4xNSA3LjE1IDAgMCAwIDguNDEgMHoiIGZpbGw9IiM4MDgwODAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9zdmc+" />                  </div>
                  <div>
                    <h1 className="text-md modalTitle font-montserrat text-green-900">Email</h1>
                    <h1 className="text-sm font-montserrat text-green-800">{info.email}</h1>
                  </div>
                </div>
                <div className="flex flex-row gap-2">
                  <div>
                    <img className="w-6" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMi41NCAyLjU0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsYXNzPSIiPjxnPjxjaXJjbGUgY3g9IjEuMjciIGN5PSIxLjI3IiByPSIxLjI3IiBmaWxsPSIjODA4MDgwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjNDhiMDJjIj48L2NpcmNsZT48ZyBmaWxsPSIjZmZmIj48cGF0aCBkPSJNMS42NCAxLjkxMkEzLjUyNyAzLjUyNyAwIDAgMSAuNjI3LjlDLjYxMy44NzguNjAzLjg1Ni42MTUuODQ0TC43MzcuNzIybC4xLS4wOThhLjA0OS4wNDkgMCAwIDEgLjA2OCAwbC4xMi4xMmMuMDIuMDIuMDE2LjA0NyAwIC4wNy0uMDE4LjAyNy0uMTIuMTUtLjEwMy4xNzMuMTcuMjQyLjM3Ni40NDkuNjE2LjYyLjA0Ny4wMzQuMTQzLS4wNjIuMTktLjA5Mi4wMjEtLjAxNS4wNS0uMDIuMDY4IDBsLjEyLjEyYS4wNDkuMDQ5IDAgMCAxIDAgLjA2OWwtLjA5OC4wOTgtLjAwNS4wMDUtLjExOC4xMThjLS4wMTIuMDEyLS4wMzMuMDAyLS4wNTUtLjAxM3oiIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiNmZmZmZmYiIGNsYXNzPSIiPjwvcGF0aD48cGF0aCBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0uNTk2LjkyLjY2Ljg4bC4wMjUuMDM3LjAyNS4wMzcuMDI2LjAzNy4wMjYuMDM2LjAyNy4wMzYuMDI3LjAzNi4wMjguMDM1LjAyOC4wMzUuMDI4LjAzNC4wMjkuMDM0LjAyOS4wMzMuMDMuMDMzLjAzLjAzMy4wMy4wMzIuMDMuMDMyLjAzMS4wMzIuMDMyLjAzMS4wMzIuMDMuMDMyLjAzMS4wMzMuMDMuMDMzLjAzLjAzMy4wMjguMDM0LjAzLjAzNC4wMjcuMDM1LjAyOC4wMzUuMDI4LjAzNi4wMjcuMDM2LjAyNi4wMzYuMDI3LjAzNy4wMjYuMDM3LjAyNS4wMzcuMDI1LS4wNDEuMDYyLS4wMzgtLjAyNS0uMDM4LS4wMjYtLjAzOC0uMDI2LS4wMzctLjAyNy0uMDM2LS4wMjgtLjAzNy0uMDI3LS4wMzUtLjAyOC0uMDM2LS4wMjktLjAzNS0uMDI5LS4wMzUtLjAyOS0uMDM0LS4wMy0uMDM0LS4wMy0uMDMzLS4wMy0uMDMzLS4wMzEtLjAzMi0uMDMyLS4wMzMtLjAzMS0uMDMxLS4wMzItLjAzMi0uMDMzLS4wMy0uMDMzLS4wMzEtLjAzM0wuOSAxLjMybC0uMDMtLjAzNC0uMDMtLjAzNS0uMDI4LS4wMzUtLjAyOS0uMDM2LS4wMjgtLjAzNi0uMDI4LS4wMzYtLjAyNy0uMDM2LS4wMjctLjAzOEwuNjQ4Ljk5Ny42MjIuOTU5LjU5Ni45MjF6TS41ODguODE5LjY0MS44Ny42NDIuODcuNjQzLjg2OC42NDQuODY3LjY0NS44NjVWLjg2NEwuNjQ3Ljg2MlYuODZoLjAwMVYuODU3Ljg2bC4wMDEuMDAxdi4wMDFMLjY1Ljg2NC42NS44NjV2LjAwMWwuMDAyLjAwMnYuMDAxbC4wMDEuMDAyLjAwMS4wMDEuMDAxLjAwMi4wMDEuMDAyLjAwMS4wMDIuMDAyLjAwMS0uMDYzLjA0MkwuNTk1LjkxOC41OTMuOTE2LjU5Mi45MTQuNTkuOTEuNTkuOTEuNTg3LjkwNi41ODYuOTA0LjU4NC45Vi44OThMLjU4MS44OTYuNTguODkzLjU3OS44OVYuODg4TC41NzYuODg1Vi44ODJMLjU3NC44NzlWLjg3NkwuNTczLjg3Mi41NzMuODdWLjg0NkwuNTc0Ljg0Mi41NzYuODM3LjU3OC44MzMuNTguODMuNTgzLjgyNS41ODUuODIxek0uNzcuNzA0LjcwNS43NGwuMDU5LjAwOEwuNzYuNzUyLjc1Ni43NTYuNzUyLjc2Ljc1Ljc2NC43NDUuNzY4Ljc0Ljc3LjczNy43NzUuNzMzLjc4LjczLjc4My43MjYuNzg3LjcyMi43OS43MTguNzk0LjcxNC43OTguNzEuODAyLjcwNy44MDYuNzAzLjgxLjY5OS44MTMuNjk1LjgxNy42OTEuODIxLjY4Ny44MjUuNjg0LjgyOS42OC44MzMuNjc2LjgzNi42NzIuODQuNjY4Ljg0NC42NjQuODQ4LjY2MS44NTIuNjU3Ljg1Ni42NTMuODU5LjY0OS44NjMuNjQ1Ljg2Ny42NDEuODcxLjU4OC44MTguNTkyLjgxNC41OTYuODEuNi44MDYuNjA0LjgwMy42MDguNzk5LjYxLjc5NS42MTUuNzkuNjIuNzg3LjYyMy43ODMuNjI3Ljc4LjYzLjc3Ni42MzQuNzcyLjYzOC43NjguNjQyLjc2NC42NDYuNzYuNjUuNzU3LjY1My43NTMuNjU3Ljc0OS42NjEuNzQ1LjY2NS43NDEuNjY5LjczNy42NzMuNzM0LjY3Ni43My42OC43MjYuNjg0LjcyMi42ODguNzE4LjY5Mi43MTUuNjk2LjcxLjY5OS43MDcuNzAzLjcwMy43MDcuNjk5LjcxMS42OTV6TS43NjQuNzQ4LjcxLjY5NWguMDAxTC43MTQuNjkyLjcxNS42OTIuNzE3LjY5LjcxOC42OS43Mi42ODkuNzIyLjY4OGguMDAxTC43MjUuNjg2LjcyNy42ODZILjczTC43MzIuNjg0aC4wMTZMLjc1LjY4OGguMDAzTC43NTUuNjloLjAwMWwuMDAyLjAwMkguNzZMLjc2LjY5NGwuMDAyLjAwMXYuMDAxbC4wMDIuMDAyLjAwMS4wMDFMLjc2OC43Vi43TC43Ny43MDN2LjAwMWwuMDAxLjAwMi4wMDEuMDAyVi43MUwuNzc0Ljcxdi4wMDJsLjAwMS4wMDJWLjczM0wuNzcyLjczNHYuMDAyTC43Ny43Mzh2LjAwMUwuNzcuNzQxLjc2OS43NDMuNzY4Ljc0NC43NjYuNzQ2di4wMDF6bTAgLjAwMUwuNzA1Ljc0MVYuNzRMLjc3LjcwNHpNLjcwNS43NDEuNzcxLjcwNXYuMDAybC4wMDEuMDAxLjAwMS4wMDJ2LjAwMmwuMDAxLjAwMnYuMDAzTC43NzYuNzJWLjczMkwuNzczLjczM3YuMDAyTC43NzIuNzM3Ljc3Mi43MzhWLjc0TC43Ny43NDJ2LjAwMUwuNzY3Ljc0NXYuMDAxTC43NjUuNzQ3Ljc2NS43NS43NjMuNzUuNzYyLjc1MS43NjEuNzUyLjc1OS43NTRILjc1N0wuNzU2Ljc1N0guNzU0TC43NTIuNzU3Ljc1MS43NThILjc0OUwuNzQ3Ljc2SC43NDNMLjc0Mi43NkguNzI5TC43MjcuNzU4SC43MjZMLjcyNC43NTZILjcyMkwuNzIxLjc1NkguNzE5TC43MTguNzUzSC43MTZMLjcxNS43NTEuNzEzLjc1MS43MTIuNzUuNzEuNzQ4LjcwOS43NDdWLjc0NUwuNzA2Ljc0NC43MDYuNzQyek0uODYzLjY1Ljc2NC43NDkuNzExLjY5NmwuMS0uMDk4ek0uOTMyLjU5OC44NzkuNjVWLjY1SC44NzdMLjg3Ni42NDhILjg3NUwuODc0LjY0N0guODY1TC44NjQuNjVILjg2M1YuNjVILjg2MkwuODEuNTk5LjgxMy41OTUuODE2LjU5Mi44Mi41ODkuODI0LjU4Ny44MjcuNTg1LjgzMS41ODIuODM1LjU4LjgzOS41OC44NDIuNTc3aC4wMDVMLjg1LjU3NGguMDA0TC44NTkuNTcyaC4wMjRsLjAwNC4wMDEuMDA0LjAwMS4wMDQuMDAxTC45LjU3Ny45MDMuNTguOTA3LjU4bC4wMDQuMDAyLjAwNC4wMDMuMDAzLjAwMi4wMDQuMDAyLjAwNC4wMDMuMDAzLjAwM3ptLjEyLjEyTDEgLjc3Ljg4LjY1LjkzMi41OThsLjEyLjEyem0uMDA0LjExNkwuOTk1Ljc5MlYuNzkxTC45OTYuNzlWLjc4OUwuOTk5Ljc4OFYuNzg2TDEgLjc4M1YuNzgyTDEgLjc4MVYuNzc4bC4wMDEtLjAwMVYuNzcySDFMLjk5OS43N2wuMDUzLS4wNTMuMDAzLjAwMy4wMDMuMDAzLjAwMy4wMDQuMDAyLjAwMy4wMDIuMDA0LjAwMi4wMDQuMDAyLjAwNC4wMDIuMDA0LjAwMS4wMDQuMDAxLjAwNC4wMDEuMDA0di4wMDRsLjAwMS4wMDRWLjc5bC0uMDAxLjAwNC0uMDAxLjAwNEwxLjA3Mi44bC0uMDAxLjAwNC0uMDAxLjAwNC0uMDAyLjAwMy0uMDAxLjAwMy0uMDAyLjAwNC0uMDAxLjAwMy0uMDAyLjAwMy0uMDAyLjAwMy0uMDAxLjAwM3pNLjk1Mi45NjZsLS4wNi4wNDNMLjg4NC45OTYuODgzLjk4NHYtLjAxTC44ODQuOTY3Ljg4Ni45Ni44OS45NS44OTIuOTQ1Ljg5NS45MzguODk5LjkzLjkwMi45MjQuOTA2LjkxNy45MTEuOTA5LjkxNS45MDIuOTIuODk1LjkyNS44ODguOTMuODguOTM1Ljg3My45NC44NjYuOTQ1Ljg2Ljk1Ljg1Mi45NTUuODQ1Ljk2Ljg0Ljk2NS44MzIuOTY5LjgyNi45NzQuODIuOTc4LjgxNS45ODIuODEuOTg1LjgwNS45ODguODAxLjk5MS43OTcuOTkzLjc5NC45OTUuNzkybC4wNjEuMDQyLS4wMDIuMDA0LS4wMDMuMDA0LS4wMDMuMDA0LS4wMDMuMDA0LS4wMDQuMDA1LS4wMDMuMDA1LS4wMDUuMDA2TDEuMDMuODdsLS4wMDQuMDA2LS4wMDUuMDA2LS4wMDUuMDA3LS4wMDUuMDA2LS4wMDQuMDA3TDEgLjkxLjk5Ni45MTYuOTkxLjkyMy45ODcuOTMuOTgyLjkzNi45NzguOTQzLjk3NC45NDkuOTcxLjk1NS45NjcuOTYxLjk2NS45NjYuOTYyLjk3Ljk2Ljk3NS45Ni45NzguOTU4Ljk4MXYuMDAxLS4wMDNMLjk1NS45NzN6bS0uMDYuMDQzLjA2LS4wNDMuMDAyLjAwMVYuOTdMLjk1Ni45N2wuMDAxLjAwMnYuMDAybC4wMDIuMDAyVi45OEwuOTYuOTgzVi45OTVMLjk1Ny45OTd2LjAwMkwuOTU3IDF2LjAwMmwtLjAwMi4wMDJ2LjAwMWwtLjAwMS4wMDItLjAwMS4wMDEtLjAwMS4wMDItLjAwMi4wMDF2LjAwMmwtLjAwMi4wMDEtLjAwMS4wMDEtLjAwMi4wMDJILjk0NGwtLjAwMi4wMDJILjk0bC0uMDAxLjAwMkguOTM3bC0uMDAyLjAwMUguOTMzbC0uMDAxLjAwMUguOTNsLS4wMDIuMDAxSC45MTJMLjkxIDEuMDIySC45MWwtLjAwMi0uMDAxLS4wMDItLjAwMS0uMDAxLS4wMDEtLjAwMi0uMDAxLS4wMDEtLjAwMS0uMDAyLS4wMDEtLjAwMS0uMDAxLS4wMDItLjAwMS0uMDAxLS4wMDItLjAwMS0uMDAxLS4wMDItLjAwMnptLjY2OC41NjktLjA0My4wNi0uMDIzLS4wMTYtLjAyMy0uMDE3LS4wMjItLjAxNy0uMDIyLS4wMTctLjAyMi0uMDE3LS4wMjItLjAxOC0uMDIxLS4wMTdMMS4zNCAxLjVsLS4wMi0uMDE4LS4wMjEtLjAxOS0uMDIxLS4wMTgtLjAyLS4wMTktLjAyLS4wMTktLjAyMS0uMDItLjAyLS4wMTgtLjAyLS4wMi0uMDE5LS4wMi0uMDItLjAyLS4wMTgtLjAyLS4wMTktLjAyLS4wMTktLjAyLS4wMTgtLjAyMi0uMDE4LS4wMi0uMDE4LS4wMjItLjAxOC0uMDIxLS4wMTgtLjAyMi0uMDE3LS4wMjJMLjk1OCAxLjFsLS4wMTctLjAyMi0uMDE3LS4wMjMtLjAxNi0uMDIyLS4wMTctLjAyMy4wNjEtLjA0My4wMTYuMDIyLjAxNi4wMjIuMDE3LjAyMi4wMTYuMDIxLjAxNy4wMjIuMDE3LjAyMS4wMTcuMDIxLjAxNy4wMi4wMTguMDIxLjAxNy4wMjEuMDE4LjAyLjAxOC4wMi4wMTguMDIuMDE5LjAyLjAxOS4wMi4wMTkuMDE4LjAxOS4wMi4wMTkuMDE4LjAyLjAxOS4wMi4wMTguMDIuMDE4LjAyLjAxOC4wMi4wMTguMDIuMDE4LjAyLjAxNy4wMjIuMDE3LjAyLjAxNy4wMjIuMDE3LjAyMS4wMTcuMDIyLjAxNi4wMjIuMDE2LjAyMi4wMTd6bS0uMDQzLjA2LjA0My0uMDZoLjAwMmwuMDAxLjAwMi4wMDIuMDAxLjAwMS4wMDJoLjAwMWwuMDAxLjAwMi4wMDEuMDAyLjAwMS4wMDEuMDAxLjAwMi4wMDEuMDAydi4wMDFsLjAwMi4wMDJ2LjAwM2wuMDAxLjAwMlYxLjYxOGwtLjAwMS4wMDJ2LjAwMWwtLjAwMS4wMDItLjAwMS4wMDItLjAwMS4wMDEtLjAwMS4wMDItLjAwMS4wMDItLjAwMS4wMDEtLjAwMi4wMDJ2LjAwMWwtLjAwMi4wMDEtLjAwMi4wMDJoLS4wMDFsLS4wMDIuMDAyaC0uMDAxbC0uMDAyLjAwMmgtLjAwMWwtLjAwMi4wMDFoLS4wMDJsLS4wMDEuMDAyaC0uMDA2bC0uMDAxLjAwMUgxLjUzbC0uMDAyLS4wMDFoLS4wMDFsLS4wMDItLjAwMS0uMDAyLS4wMDFoLS4wMDJMMS41MiAxLjY0aC0uMDAyem0uMTktLjE1NC4wNC4wNjItLjAwMy4wMDItLjAwNC4wMDMtLjAwNC4wMDQtLjAwNS4wMDMtLjAwNi4wMDUtLjAwNS4wMDQtLjAwNi4wMDQtLjAwNi4wMDUtLjAwNi4wMDUtLjAwNy4wMDUtLjAwNi4wMDUtLjAwNy4wMDUtLjAwNy4wMDUtLjAwNy4wMDYtLjAwNy4wMDQtLjAwNy4wMDUtLjAwNy4wMDUtLjAwOC4wMDUtLjAwNy4wMDQtLjAwOC4wMDQtLjAwOC4wMDQtLjAwOC4wMDQtLjAwOC4wMDMtLjAwOC4wMDMtLjAwOS4wMDItLjAwOS4wMDEtLjAwOS4wMDFoLS4wMWwtLjAxLS4wMDEtLjAxLS4wMDMtLjAxLS4wMDQtLjAwOC0uMDA2LjA0My0uMDZoLjAwNGwuMDAzLS4wMDEuMDA0LS4wMDEuMDA0LS4wMDIuMDA0LS4wMDEuMDA1LS4wMDIuMDA1LS4wMDMuMDA2LS4wMDMuMDA1LS4wMDMuMDA2LS4wMDQuMDA2LS4wMDQuMDA2LS4wMDQuMDA3LS4wMDQuMDA2LS4wMDUuMDA2LS4wMDQuMDA2LS4wMDUuMDA3LS4wMDUuMDA2LS4wMDUuMDA2LS4wMDUuMDA2LS4wMDQuMDA1LS4wMDUuMDA2LS4wMDQuMDA2LS4wMDUuMDA1LS4wMDQuMDA2LS4wMDQuMDA1LS4wMDR6bS4xMTYuMDA0LS4wNTMuMDUzaC0uMDAxbC0uMDAxLS4wMDFoLS4wMWwtLjAwMi4wMDEtLjAwMi4wMDEtLjAwMS4wMDFIMS43NXYuMDAxbC0uMDAyLjAwMWgtLjAwMWwtLjA0Mi0uMDYxLjAwMy0uMDAyLjAwMy0uMDAyLjAwNC0uMDAyLjAwMy0uMDAyLjAwMy0uMDAxLjAwMy0uMDAyLjAwMy0uMDAxLjAwNC0uMDAxLjAwMy0uMDAxLjAwNC0uMDAyaC4wMDNsLjAwNC0uMDAxLjAwNC0uMDAxaC4wMDRsLjAwMy0uMDAxaC4wMmwuMDA0LjAwMS4wMDQuMDAxLjAwNC4wMDEuMDA0LjAwMi4wMDQuMDAxLjAwNC4wMDIuMDA0LjAwMi4wMDQuMDAyLjAwNC4wMDMuMDAzLjAwMi4wMDMuMDAzLjAwNC4wMDN6bS4wNjcuMTczLS4xMi0uMTIuMDUzLS4wNTMuMTIuMTJ6bS4wNTMuMDctLjA1My0uMDU0di0uMDAxaC4wMDF2LS4wMDFsLjAwMS0uMDAxVjEuNjdoLjAwMXYtLjAwNmgtLjAwMXYtLjAwMWwtLjAwMS0uMDAxdi0uMDAxSDEuODlsLjA1My0uMDU0LjAwMy4wMDQuMDAyLjAwMy4wMDMuMDAzLjAwMy4wMDQuMDAyLjAwNC4wMDIuMDAzLjAwMi4wMDQuMDAyLjAwNC4wMDEuMDA0LjAwMS4wMDQuMDAxLjAwNC4wMDEuMDA0LjAwMS4wMDR2LjAyOWwtLjAwMi4wMDR2LjAwNGwtLjAwMi4wMDQtLjAwMS4wMDQtLjAwMi4wMDQtLjAwMi4wMDMtLjAwMi4wMDQtLjAwMi4wMDQtLjAwMy4wMDQtLjAwMy4wMDMtLjAwMi4wMDN6bS0uMTUyLjA0NS4wOTktLjA5OS4wNTMuMDUzLS4wOTkuMDk5em0wIDAgLjA1My4wNTMtLjAwMS4wMDEtLjAwMi4wMDEtLjAwMS4wMDJoLS4wMDJsLS4wMDEuMDAyaC0uMDAybC0uMDAxLjAwMS0uMDAyLjAwMUgxLjgzbC0uMDAyLjAwMWgtLjAwMWwtLjAwMi4wMDFIMS44MDdsLS4wMDItLjAwMS0uMDAxLS4wMDFoLS4wMDJMMS44IDEuODM0SDEuOGwtLjAwMi0uMDAxLS4wMDEtLjAwMS0uMDAyLS4wMDJoLS4wMDFsLS4wMDItLjAwMi0uMDAxLS4wMDItLjAwMS0uMDAxLS4wMDEtLjAwMi0uMDAyLS4wMDFWMS44MmwtLjAwMS0uMDAxLS4wMDEtLjAwMi0uMDAxLS4wMDJ2LS4wMDFsLS4wMDEtLjAwMnYtLjAwMkwxLjc4IDEuODF2LS4wMTdsLjAwMS0uMDAyLjAwMS0uMDAydi0uMDAybC4wMDItLjAwMXYtLjAwMmwuMDAxLS4wMDEuMDAyLS4wMDJWMS43OGwuMDAyLS4wMDJ6bS0uMDA1LjAwNS4wMDUtLjAwNS4wNTMuMDUzLS4wMDUuMDA1em0wIDAgLjA1My4wNTMtLjAwMS4wMDEtLjAwMi4wMDJoLS4wMDFsLS4wMDIuMDAyaC0uMDAxbC0uMDAyLjAwMmgtLjAwMmwtLjAwMS4wMDFoLS4wMDJsLS4wMDIuMDAxaC0uMDAxbC0uMDAyLjAwMUgxLjgwMkwxLjggMS44NDJIMS44bC0uMDAyLS4wMDJoLS4wMDJsLS4wMDEtLjAwMS0uMDAyLS4wMDEtLjAwMi0uMDAxLS4wMDEtLjAwMS0uMDAyLS4wMDJ2LS4wMDFsLS4wMDItLjAwMS0uMDAxLS4wMDItLjAwMi0uMDAxdi0uMDAybC0uMDAyLS4wMDJ2LS4wMDFsLS4wMDEtLjAwMi0uMDAxLS4wMDFWMS44MmwtLjAwMS0uMDAydi0uMDAybC0uMDAxLS4wMDFWMS43OTdsLjAwMS0uMDAydi0uMDAybC4wMDItLjAwMVYxLjc5bC4wMDEtLjAwMi4wMDEtLjAwMS4wMDEtLjAwMi4wMDItLjAwMXYtLjAwMnptLS4xMTcuMTE3LjExNy0uMTE3LjA1My4wNTMtLjExNy4xMTd6bS0uMDUuMDQ1LjA0MS0uMDYyLjAwMi4wMDEuMDAyLjAwMS4wMDIuMDAxLjAwMS4wMDEuMDAyLjAwMmguMDAxbC4wMDIuMDAxaC4wMDFsLjAwMi4wMDJoLjAwMmwuMDAxLjAwMWguMDAxbC4wMDEuMDAxaC4wMDItLjAwM2wtLjAwMi4wMDFoLS4wMDFsLS4wMDIuMDAxLS4wMDEuMDAxLS4wMDIuMDAxLS4wMDEuMDAxLS4wMDEuMDAxLjA1My4wNTMtLjAwNC4wMDMtLjAwMy4wMDMtLjAwNC4wMDMtLjAwNC4wMDItLjAwNS4wMDItLjAwNC4wMDEtLjAwNC4wMDFIMS42OWwtLjAwNC4wMDFIMS42N2wtLjAwNC0uMDAxaC0uMDAzbC0uMDAzLS4wMDJoLS4wMDNsLS4wMDMtLjAwMmgtLjAwM0wxLjY1IDEuOTZoLS4wMDJsLS4wMDMtLjAwMi0uMDAzLS4wMDEtLjAwMi0uMDAyLS4wMDMtLjAwMS0uMDAyLS4wMDItLjAwMy0uMDAxLS4wMDItLjAwMS0uMDAzLS4wMDItLjAwMi0uMDAxLS4wMDMtLjAwMnoiIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiNmZmZmZmYiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9nPjwvc3ZnPg==" />
                     </div>
                  <div>
                    <h1 className="text-md modalTitle font-montserrat text-green-900">Phone</h1>
                    <h1 className="text-sm font-montserrat text-green-800">{info.phone}</h1>
                  </div>
                </div>
                <div className="flex flex-row gap-2">
                  <div>
                  <img className="w-6" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNjQgNjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxwYXRoIGQ9Ik0zMiAwQTI0LjAzMiAyNC4wMzIgMCAwIDAgOCAyNGMwIDE3LjIzIDIyLjM2IDM4LjgxIDIzLjMxIDM5LjcyYS45OS45OSAwIDAgMCAxLjM4IDBDMzMuNjQgNjIuODEgNTYgNDEuMjMgNTYgMjRBMjQuMDMyIDI0LjAzMiAwIDAgMCAzMiAwem0wIDM1YTExIDExIDAgMSAxIDExLTExIDExLjAwNyAxMS4wMDcgMCAwIDEtMTEgMTF6IiBmaWxsPSIjODA4MDgwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg==" />
                    </div>
                  <div>
                    <h1 className="text-md modalTitle font-montserrat text-green-900">Location</h1>
                    
                      {
                        info.area && info.city ? 
                        <h1 className="text-sm font-montserrat text-green-800"> {info.area}, {info.city}</h1>
                        :
                        <h1 className="text-sm font-montserrat text-red-500">Not Given</h1>

                      }
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className=" font-montserrat text-green-700 hover:bg-green-700 hover:text-white duration-150  text-md modalTitle rounded border-2 border-green-700 py-2">Download CV</button>
          <TutorModal
            isVisible={isModalVisible}
            onClose={closeModal}
            handleImageUpload={handleImageUpload}
            loading={loading}
            updateImage={updateImage}
          />
        </div>

        <div className="w-[75%]">
          {active === "editProfile" && <EditProfile profileData={profileData} title="1" />}
          {active === "viewProfile" && <ViewProfile profileData={profileData} title="2" />}
        </div>
      </div>
      <Modal isVisible={isModalVisible} onClose={closeModal} />
    </div>
  );
};

export default TutorProfileGreen;
